/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react'
import { UserContext } from 'account'
import { LayoutContext } from 'common/ducks/index'
import styled from 'styled-components'
import useApi from 'common/hooks/useApi'
import useAppTitle from 'common/hooks/useAppTitle'
import { NotificationsNoneOutlined } from '@mui/icons-material'
import { Switch, FormControlLabel, FormGroup} from '@mui/material';
import { messaging } from './firebase'
import { getToken, getMessaging, onMessage } from "firebase/messaging";
import { FIREBASE_VAPID_KEY } from 'common/env'
import logo from 'static/img/logo.png'
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  Conversation,
  ConversationList,
  Avatar,
  ConversationHeader,
  ExpansionPanel,
  } from '@chatscope/chat-ui-kit-react';
import styles from '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import ConversationPopUp from './ConversationPopUp'

if ('serviceWorker' in navigator) {
navigator.serviceWorker.register('./firebase-messaging-sw.js')
  .then(registration => console.log('SW registered'))
  .catch(err => console.error('SW registration failed', err));
}

function MessagesChart() {
  const user = useContext(UserContext)
  const { setAppLoading } = useContext(LayoutContext)
  const [activeChat, setActiveChat] = useState()
  const [fbToken, setFBToken] = useState('')
  const [notif, setNotif] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if ("Notification" in window) {
      if(Notification.permission ==='granted'){
        setNotif(true)
      }
    }
  }, [])

  const messaging = getMessaging();
  onMessage(messaging, (payload) => {
    if ("Notification" in window) {
      const notification = new Notification(payload.notification.title, {
              body: payload.notification.body,
              icon: '/img/logos/mobile/72x72.png',
              vibrate: [200, 100, 200],
              tag: "message",
            });

      notification.onclick = (event) => {
        event.preventDefault();
        window.open('/messages');
      }
    }
  });

  useAppTitle('Messages')

  const [{ data: messages, loading: messagesLoading }, messagesCall] = useApi('messages/')

  const [, sendTokenApi] = useApi(
      {
        method: 'POST',
        url: 'gfbt/',
      },
      { manual: true }
    )

  async function grabToken() {
    if ("Notification" in window) {
      await Notification.requestPermission().then(perm => {
        if (perm === 'granted') {
          setNotif(true)
          try{
            getToken(
              messaging,
              {vapidKey:FIREBASE_VAPID_KEY})
              .then((token)=>{
                setFBToken(token)
                sendGFBT(token)})
          } catch(error){
            console.log(error)
          }
        }
      })
    }
  }

  async function sendGFBT(token){
     const body = {
        'gfbt': token,
        }
     await sendTokenApi({
          data: body,
       })
    }

  useEffect(() => {
        setAppLoading(messagesLoading)
    }, [messagesLoading, setAppLoading])

  return (
    <MessagesChart.Stylesheet>
      <div style={{ position:"relative", height: "700px" }}>
        <FormGroup>
          <FormControlLabel control={
            <Switch
            checked={notif}
            name='Notifications' style={{color: 'teal'}}

            onChange={(event) => {if(event.target.value){grabToken()}}}/>
            } label='Notifications' labelPlacement="start"/>
        </FormGroup>
        <ExpansionPanel
          open
          title="Conversations"
        >
          <ConversationList
            style={{
              height: '500px'
            }}
          >
            {messages?.map((row) => {
              try {
                const obj = JSON.parse(row?.lastMessage?.message)
                return(
                  <Conversation
                    info='Attachment'
                    lastSenderName={row?.lastMessage.sender}
                    name={row?.name}
                    onClick={() => {setActiveChat(row); setOpen(true)}}
                  >
                    <Avatar
                      name={row?.name}
                      src={row?.picture || logo}
                    />
                  </Conversation>
                )
              }
              catch (error) {
                if(!row?.lastMessage.message?.type){
                  return(
                    <Conversation
                    info={row?.lastMessage.message}
                    lastSenderName={row?.lastMessage.sender}
                    name={row?.name}
                    onClick={() => {setActiveChat(row); setOpen(true)}}
                    >
                      <Avatar
                        name={row?.name}
                        src={row?.picture || logo}
                      />
                    </Conversation>
                  )
                } else {
                  return(
                    <Conversation
                    info='Attachment'
                    lastSenderName={row?.lastMessage.sender}
                    name={row?.name}
                    onClick={() => {setActiveChat(row); setOpen(true)}}
                    >
                      <Avatar
                        name={row?.name}
                        src={row?.picture || logo}
                      />
                    </Conversation>
                  )
                }
              }
            })}
            </ConversationList>
          </ExpansionPanel>
          <ConversationPopUp open={open} onOpenChange={setOpen} activeChat={activeChat} messagesCall={messagesCall} fbToken={fbToken}/>
      </div>
    </MessagesChart.Stylesheet>
  )
}

MessagesChart.Stylesheet = styled.div`

.cs-expansion-panel__header{
  background-color: darkcyan;
  color: white;
  font-size: 1em;
}
`

export default MessagesChart
